import { render } from "./HomeCard.vue?vue&type=template&id=023ec908"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=023ec908&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__